<template>
  <v-container>
    <h1>Butikker</h1>
    <AdminBreadcrumbs tail-text="Butikker" />

    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="white--text orange">
        Liste over butikker
      </v-card-title>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="3" offset="0">
            <v-btn
              color="success"
              :to="{
                name: 'adminVendorCreate',
              }"
            >
              <v-icon left> mdi-store-plus </v-icon>
              Lag ny butikk
            </v-btn>
          </v-col>
          <v-col cols="3" offset="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Søk"
              single-line
              hide-details
            />
          </v-col>
        </v-row>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="vendors"
        :search="search"
        sort-by="name"
        class="orange lighten-5"
      >
        <template v-slot:item.name="{ item }">
          <router-link
            :to="{
              name: 'adminVendorDetail',
              params: {
                vendorId: item.id.toString(),
              },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";

export default {
  name: "AdminVendors",

  components: {
    AdminBreadcrumbs,
  },

  data: function () {
    return {
      vendors: [],
      headers: [
        {
          text: "Navn",
          value: "name",
        },
      ],
      search: "",
    };
  },

  computed: {
    organization() {
      return this.$store.state.auth.organization;
    },
  },

  async created() {
    this.vendors = await backend.get("vendors/", {
      organization: this.organization.id,
    });
  },
};
</script>

